import { isElectron as isElectronEnvironment } from 'react-device-detect';
import { isDevelopmentFunction, IsElectronFunction, isVSAKioskFunction } from './EnvironmentFlags.types';
import { KioskType } from '../../context/Kiosk/kiosk.types';

/**
 * The `isElectron` function returns `true` when the runtime environment is Electron.
 *
 * To view the type definition, click {@link IsElectronFunction here}.
 */
export const isElectron: IsElectronFunction = () => {
    return isElectronEnvironment;
};
/**
 * The `isDevelopment` function returns `true` when either the environment is not `production` or
 * if `process.env.REACT_APP_FORCE_DEV` is true.
 *
 * To view the type definition, click {@link isDevelopmentFunction here}.
 */
export const isDevelopment: isDevelopmentFunction = () => {
    return process.env.REACT_APP_FORCE_DEV === 'true' || process.env.NODE_ENV !== 'production';
};

/**
 * The `isVSAKiosk` function returns `true` when the parameter given is a `VSA` or `Hybrid` kiosk type.
 *
 * To view the type definition, click {@link isVSAKioskFunction here}.
 */
export const isVSAKiosk: isVSAKioskFunction = (kioskType) => {
    const VSAKioskTypes: KioskType[] = ['vsa2', 'vsa3', 'vsa4', 'hybrid'];

    return VSAKioskTypes.includes(kioskType);
};
